import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

///https://gist.github.com/tnqsoft/38aed9ee97d200bb899f61e68ebb2a9d
@Directive({
	selector: 'img[thumbnail]'
})
export class ThumbnailDirective implements OnChanges {

	@Input() public image: any;

	constructor(private el: ElementRef) { }

	public ngOnChanges(changes: SimpleChanges) {

		let reader = new FileReader();
		let el = this.el;

		reader.onloadend = (readerEvent) => {
			let myimage = new Image();
			myimage.onload = (imageEvent) => {
				// Resize the image
				let canvas = document.createElement('canvas');
				let maxSize = 70;
				let width = myimage.width;
				let height = myimage.height;
				if (width > height) {
					if (width > maxSize) {
						height *= maxSize / width;
						width = maxSize;
					}
				} else {
					if (height > maxSize) {
						width *= maxSize / height;
						height = maxSize;
					}
				}
				canvas.width = width;
				canvas.height = height;
				canvas.getContext('2d').drawImage(myimage, 0, 0, width, height);
				el.nativeElement.src = canvas.toDataURL('image/jpeg');
			};
			el.nativeElement.src = reader.result as string;
		};

		if (this.image) {
			return reader.readAsDataURL(this.image);
		}
	}
}
